<template>
  <div id="container">
    <div id="wrap">
      <div class="top" :style="{ backgroundImage: 'url(' + info.thumb + ')' }">
        <div class="top-mask"></div>
      </div>
      <div id="content">
        <!-- 简介 -->
        <div class="box" v-if="!isEmpty">
          <h1>{{ info.topic }}</h1>
          <div class="desc" v-if="desc">
            {{ info.description !== undefined && info.description.length > 76 ? info.description.slice(0, 76) + '...' : info.description }}
            <a href="javascript:;" class="btn-arr cur" @click="desc = !desc" v-if="info.description !== undefined && info.description.length > 76">展开<i></i></a>
          </div>
          <div class="desc" v-if="!desc">
            {{ info.description }}
            <a href="javascript:;" class="btn-arr" @click="desc = !desc">收起<i></i></a>
          </div>
        </div>

        <!-- 特邀答主 -->
        <div class="box" v-if="!isEmpty && mp != null && mp != ''">
          <h1>特邀答主</h1>
          <div class="swiper" id="swiper">
            <swiper ref="mySwiper" :options="swiperOptions">
              <swiper-slide v-for="(item, index) in mp" :key="index">
                <a :href="item.link">
                <div class="thumb" :style="'background-image: url(' + item.thumb + ');'"></div>
                <p>{{ item.title }}</p>
                </a>
              </swiper-slide>
            </swiper>
          </div>
        </div>
<!--         
        <div class="box" v-if="!isEmpty && mp != null">
          <h1>特邀答主</h1>
          <div class="swiper" id="swiper">
            <swiper ref="mySwiper" :options="swiperOptions">
              <swiper-slide v-for="(item, index) in mp" :key="index">
                <a :href="isAPP ? 'javascript:AppJS2Native.appOpenVchannels(\''+ item.api +'\');' : item.url">
                <div class="thumb" :style="'background-image: url(' + item.list_thumb + ');'"></div>
                <p>{{ item.title }}</p>
                </a>
              </swiper-slide>
            </swiper>
          </div>
        </div> -->

        <!-- 精选问答 -->

        <div class="box" v-if="!isEmpty && list.length > 0">
          <h1 class="n">精选问答</h1>
          <div class="item" v-for="(item, index) in list" :key="index">
            <a :href="item.url" class="tit"><span>{{ item.title }}</span><img src="../assets/wbd.png"
                v-if="item.is_pay == 1" /></a>
            <p>{{ item.description }}</p>
            <a :href="item.url" class="more">查看全部答案</a>
          </div>
        </div>

        <!-- 没有数据 -->
        <div v-if="isEmpty" class="box empty"><i></i>
          <p><span>暂无数据</span></p>
        </div>

      </div>


    </div>

    <a href="https://m.21jingji.com/consultationnew/addConsultation" class="share"><i></i>我要提问</a>

  </div>
</template>

<script>
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import swiper from "swiper";


let vm = null;

export default {
  name: "Home",
  components: {
    Swiper,
    SwiperSlide
    // newsSwiper
  },
  directives: {
    swiper: directive,
  },
  data() {
    return {
      isAPP: false,
      isEmpty: true,
      topImg: '',
      isAndroid: false,
      isIphone: false,
      isLoading: true,
      desc: true,
      ztId: 0,
      info: {},
      list: [],
      mp: [],
      swiperOptions: {
        loop: false,
        slidesPerView: 'auto',
        spaceBetween: 15,
        centeredSlides: false,
        // freeMode: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        on: {
          // click: function (e) {
          //   let url = this.clickedSlide.attributes["data-url"].nodeValue;
          //   window.location.href = url;
          // },
        },
      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    }
  },
  created() {
    vm = this;
    // vm.setWxShare()
  },
  mounted() {
    let _this = this;
    // 判断是否APP内打开
    let appVersion = navigator.appVersion;
    let epaper = /21epaper/gi.test(appVersion);
    let android = /android/gi.test(appVersion); //android
    let iphone = /iphone|ipod/gi.test(appVersion); //iphone|ipod
    if (epaper) {
      _this.isAPP = true;
    }
    if (android) {
      _this.isAndroid = true;
    }
    if (iphone) {
      _this.isIphone = true;
    }

    const params = _this.$route.params
    // console.log(params)
    // 初始化数据
    _this.ztId = params.id ? params.id : 0
    _this.getData(params.date,params.preview)
    // console.log(params.date, this.ztId)

    // 安卓系统 滑动冲突处理
    // setTimeout(() => {
    //     let targetbox = document.getElementById("swiper");
    //     _this.target = targetbox.offsetTop;
    //     console.log(this.target)
    //   }, 10);
    // if (_this.isAPP && _this.isAndroid) {
    //   AppJS2Native.appWebviewBannerTouch(0, 320);
    // }

  },
  beforeRouteLeave(to, from, next) {
    from.meta.keepAlive = false;
    next();
  },
  methods: {
    getData: function (dataname,preview) {
      // console.log(dataname)
      var _this = this;
      _this.isShare = false
      // 读取数据
      var preApi = ''
      if(preview == 'preview') {
        preApi = '&preview=1'
      }
      var api = "https://api.21jingji.com/daily?consultation=1"
      var apiUrl = api + '&date=' + dataname + '&id=' + _this.ztId + preApi

      // window.axios.get("/1.json?date=" + dataname).then((res) => {
        _this.$jsonp(apiUrl, { callbackName: 'callback' }).then((res) => {
        // console.log(res)
        if (res.status == 1) {
          _this.info = res.info
          _this.list = res.list
          _this.mp = res.consultationAuthor

          // 修改网页title
          // console.log(res.info.topic)
          // console.log(res.info.description)
          let htmlTitle = _this.info.topic ? _this.info.topic : '21财经'

          var title21 = document.getElementById('title21');
          title21.content = htmlTitle
          document.title = htmlTitle

          var desc21 = document.getElementById('desc21');
          desc21.content = _this.info.description

          var url21 = document.getElementById('url21');
          url21.content = window.location.href

          if (res.list == "" && res.info == "") {
            _this.isEmpty = true
          } else {
            _this.isEmpty = false
          }
        } else {
          _this.isEmpty = true
        }
      })

      // 读取数据
      _this.isLoading = true;
      setTimeout(function () {
        _this.isLoading = false;
      }, 300);

      // console.log("iscache");
      // console.log(_this);
    }
  }

};
</script>

<style lang="less">
@import url('../assets/common.less');

#wrap {
  margin: 0 auto;
  width: 750px;
  min-height: 100%;
  background-color: #f5f5f5;
  overflow: hidden;

  .top {
    position: relative;
    width: 750px;
    height: 420px;
    // .bg;
    background-color: #ddd;
    // background-image: url("../assets/top.jpg");
    background-position: center center;
    background-size: cover;
    overflow: hidden;
    z-index: 1;

    .top-mask {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 35px;
      background: linear-gradient(180deg, rgba(250, 252, 253, 0) 0%, #f5f5f5 90%);
    }
  }
}

#content {
  min-height: calc(100vh - 370px);

  .empty {
    height: calc(100vh - 680px);

    i {
      display: block;
      margin: 150px auto 20px;
      width: 240px;
      height: 240px;
      background: url("../assets/icon-empty.png") no-repeat center center / 240px 240px;
    }

    p {
      padding-bottom: 50px;
      font-size: 28px;
      color: #10509F;
      text-align: center;
      cursor: pointer;

      span {
        color: #8e8e93;
      }
    }
  }

  .box {
    position: relative;
    margin: 0 20px 20px;
    padding: 24px;
    background-color: #fff;
    box-shadow: 0px 4px 12px 0px rgba(187, 187, 187, 0.1);
    border-radius: 10px;

    &:first-child {
      .first;
    }

    &:last-child {
      margin-bottom: 60px;
    }

    h1 {
      display: block;
      margin-bottom: 15px;
      font-size: 34px;
      color: #292934;
      line-height: 48px;
      text-align: left;
      font-weight: bold;
      word-break: break-all;

      &.n {
        margin-bottom: 0;
      }
    }


    .desc {
      font-size: 24px;
      color: #8e8e93;
      line-height: 34px;

      div {
        .text(@line: 3)
      }

      .btn-arr {
        display: inline-block;
        margin: 0 10px 016px;
        color: #10509F;

        i {
          display: inline-block;
          margin-left: 6px;
          width: 22px;
          height: 12px;
          background: url("../assets/arrow.png") no-repeat right center / 22px auto;
          vertical-align: middle;
          transform: rotate(180deg);
        }

        &.cur {
          float: right;
          display: block;
          i {
          transform: rotate(0deg);
          }
        }

      }
    }

    .item {
      margin: 0 -20px;
      padding: 20px 20px 20px 72px;
      border-bottom: 1px solid #eee;

      &:last-child {
        border-bottom: none;
      }

      a {
        display: block;
      }

      .qa {
        display: block;
        content: '';
        position: absolute;
        left: -48px;
        width: 32px;
        height: 32px;
        background-repeat: no-repeat;
        background-position: center center;
        background-size: 100% 100%;
      }

      .tit {
        position: relative;
        display: block;
        margin-bottom: 15px;
        font-size: 32px;
        line-height: 44px;

        &::before {
          .qa;
          top: 10px;
          background-image: url("../assets/wen.png");
        }

        span {
          display: inline;
          margin-right: 12px;
          font-size: 32px;
          color: #292934;
          line-height: 44px;
          font-weight: bold;
          vertical-align: middle;
        }

        img {
          display: inline;
          width: 72px;
          vertical-align: middle;
        }
      }

      p {
        position: relative;
        margin-bottom: 6px;
        font-size: 24px;
        color: #8e8e93;
        line-height: 34px;
        text-align: justify;
        white-space: pre-wrap;
        word-break: break-all;

        &::before {
          .qa;
          top: 0;
          background-image: url("../assets/da.png");
        }
      }

      .more {
        font-size: 24px;
        color: #10509F;
        line-height: 34px;
      }

    }

  }
}


// 精选策划
.swiper {
  overflow: hidden;

  .swiper-container {
    padding: 15px 0 40px;

    .swiper-wrapper {
      .swiper-slide {
        width: 120px;
        height: 143px;

        .thumb {
          margin: 0 auto 12px;
          width: 120px;
          height: 120px;
          background-color: #eee;
          border: 1px solid #eee;
          border-radius: 60px;
          background-repeat: no-repeat;
          background-position: center center;
          background-size: cover;
          overflow: hidden;
          cursor: pointer;
        }

        p {
          font-size: 24px;
          color: #292934;
          line-height: 26px;
          text-align: center;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }
      }
    }

  }
}

// 提问按钮
.share {
  display: block;
  position: fixed;
  right: 0px;
  bottom: 100px;
  width: 210px;
  height: 88px;
  font-size: 26px;
  color: #fff;
  line-height: 88px;
  font-weight: 500;
  background: linear-gradient(180deg, #2886E1 0%, #195DD4 100%);
  box-shadow: -4px 6px 27px 0px rgba(0, 95, 212, 0.2), 0px 2px 10px 0px rgba(0, 95, 212, 0.45);
  border-radius: 50px 0 0 50px;
  z-index: 9;
  cursor: pointer;

  i {
    display: inline-block;
    margin: 0 6px 0 28px;
    width: 46px;
    height: 50px;
    background: url(../assets/btn.png) no-repeat center center / 100% 100%;
    vertical-align: middle;
  }
}
</style>
